const contributions = [
  { id: "CALL_INVESTMENTS", label: "Fund Investments" },
  { id: "CALL_MANAGEMENT_FEES", label: "Management Fee" },
  { id: "CALL_ORGANIZATIONAL_COSTS", label: "Organizational Costs" },
  { id: "CALL_PARTNERSHIP_EXPENSES", label: "Partnership Expenses" },
  { id: "CALL_UNALLOCATED_CAPITAL", label: "Unallocated Capital" },
];

export default contributions;
